<script setup>
import SalesPartyDocumentList from './SalesPartyDocumentList.vue';
import SalesPartyDocumentUploadDropzone from './SalesPartyDocumentUploadDropzone.vue';

defineProps({
  documents: { type: Array, default: () => [] },
  pending: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
  canUpload: { type: Boolean, default: false },
  documentTypes: { type: Array, default: () => [] },
  savingDocumentId: { type: [String, Number], default: null },
  showEmptyState: { type: Boolean, default: false },
});

const emit = defineEmits(['download', 'files', 'remove', 'saveTypes']);
const saveTypes = (document, types) => emit('saveTypes', document, types);
</script>

<template>
  <div class="grid gap-4">
    <SalesPartyDocumentUploadDropzone
      :can-upload="canUpload"
      :pending="pending"
      @files="emit('files', $event)"
    />
    <SalesPartyDocumentList
      :can-edit="canUpload"
      :document-types="documentTypes"
      :documents="documents"
      :loading="loading"
      :saving-document-id="savingDocumentId"
      :show-empty-state="showEmptyState"
      @download="emit('download', $event)"
      @remove="emit('remove', $event)"
      @save-types="saveTypes"
    />
  </div>
</template>
